// src/constants/socialPlatforms.js
//
// Single source of truth for which social platforms the admin can pick from,
// and which icon each one renders as. Both AdminSocialLinks.jsx (admin form)
// and CustomerLayout.jsx (footer) import this so they can never drift apart.
import {
  FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp, FaLinkedinIn,
  FaPinterestP, FaTelegramPlane, FaTiktok, FaLink,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export const SOCIAL_PLATFORMS = [
  { value: "facebook",  label: "Facebook",    icon: FaFacebookF   },
  { value: "instagram", label: "Instagram",   icon: FaInstagram   },
  { value: "youtube",   label: "YouTube",     icon: FaYoutube     },
  { value: "x",         label: "X (Twitter)", icon: FaXTwitter    },
  { value: "linkedin",  label: "LinkedIn",    icon: FaLinkedinIn  },
  { value: "whatsapp",  label: "WhatsApp",    icon: FaWhatsapp    },
  { value: "pinterest", label: "Pinterest",   icon: FaPinterestP  },
  { value: "telegram",  label: "Telegram",    icon: FaTelegramPlane },
  { value: "tiktok",    label: "TikTok",      icon: FaTiktok      },
];

// Falls back to a generic link icon for any platform value that isn't
// recognised (e.g. an old/renamed entry), so the footer never breaks.
export const getPlatformIcon = (value) =>
  SOCIAL_PLATFORMS.find((p) => p.value === value)?.icon || FaLink;

export const getPlatformLabel = (value) =>
  SOCIAL_PLATFORMS.find((p) => p.value === value)?.label || value;